import { Exclude, plainToInstance, Type } from 'class-transformer'
import { Guid } from 'guid-typescript'

import MessageEditorWithMediaData from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import ActionNodeAction from '../index'
import { ActionTypes } from '../types'

export class NotifyUsersAction extends ActionNodeAction<NotifyUsersAction> {
  declare type: ActionTypes.NotifyUsers
  users!: Array<number>
  @Type(() => MessageEditorWithMediaData)
  variants!: Array<MessageEditorWithMediaData>
  @Exclude()
  guid: string = Guid.create().toString()

  getNewModel() {
    return plainToInstance(NotifyUsersAction, {
      type: ActionTypes.NotifyUsers,
      users: [],
      variants: [],
    })
  }
}
